import axios from '../utils/axios'

// 订单页面数据获取
export function SubmitOrder(params) {
  return axios({
    url: '/Sale/Task/SubmitOrder',
    method: 'get',
    params: params
  })
}

// 获取剩余时间单独接口
export function RemainderPayTimeGet(params) {
  return axios({
    url: '/Sale/Task/RemainderPayTimeGet',
    method: 'get',
    params: params
  })
}

// 获取上传图片信息接口
export function UpaiyunUploadInfoGet(params) {
  return axios({
    url: '/Member/SApp/UpaiyunUploadInfoGet',
    method: 'get',
    params: params
  })
}

// 验证订单
export function CheckPlatformOrderID(data) {
  return axios({
    url: '/Sale/Task/CheckPlatformOrderID',
    method: 'post',
    data: data
  })
}

// 删除订单接口
export function DeleteOrder(data) {
  return axios({
    url: '/Sale/Task/DeleteOrder',
    method: 'post',
    data: data
  })
}

// 拼多多验证订单
export function CheckPlatformOrderIdPdd(data) {
  return axios({
    url: '/Sale/Task/CheckPlatformOrderIdPdd',
    method: 'post',
    data: data
  })
}

// 京东验证订单
export function CheckPlatformOrderIDJd(data) {
  return axios({
    url: '/Sale/Task/CheckPlatformOrderIDJd',
    method: 'post',
    data: data
  })
}

// 抖音验证订单
export function CheckPlatformOrderIDDouDian(data) {
  return axios({
    url: '/Sale/Task/CheckPlatformOrderIDDouDian',
    method: 'post',
    data: data
  })
}

// 淘工厂验证订单
export function CheckPlatformOrderIDTgc(data) {
  return axios({
    url: '/Sale/Task/CheckPlatformOrderIDTgc',
    method: 'post',
    data: data
  })
}

// 自动提交
export function SaleOrderCommit(data) {
  return axios({
    url: '/Sale/Task/SaleOrderCommit',
    method: 'post',
    data: data
  })
}

// 手动提交
export function ManualCommitOrder(data) {
  return axios({
    url: '/Sale/Task/ManualCommitOrder',
    method: 'post',
    data: data
  })
}

// 重新提交
export function ManualCommitOrderAgain(data) {
  return axios({
    url: '/Sale/Task/ManualCommitOrderAgain',
    method: 'post',
    data: data
  })
}

// 同意协议
export function AgreeProtocol(data) {
  return axios({
    url: '/Member/SApp/AgreeProtocol',
    method: 'post',
    data: data
  })
}

// 红包弹窗展现数据
export function RedPacketInfo(params) {
  return axios({
    url: '/Sale/Task/RedPacketInfo',
    method: 'get',
    params: params
  })
}
